/**
 * Readable text for a failed API call, safe to render in a toast.
 *
 * FastAPI 422s carry `detail` as an array of {loc, msg, type} objects.
 * Rendering that array as a React child throws and, with no error
 * boundary, white-screens the page (Inbox guest reply, ISS-2fa15d6f).
 */
export function apiErrorText(error, fallback = "Something went wrong") {
  const detail = error?.response?.data?.detail ?? error?.response?.data?.error;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const parts = detail
      .map(d => (typeof d === "string" ? d : d?.msg ? `${d.msg}${Array.isArray(d.loc) ? ` (${d.loc.filter(x => x !== "body").join(".")})` : ""}` : ""))
      .filter(Boolean);
    if (parts.length) return parts.join("; ");
  }
  if (detail && typeof detail === "object") {
    if (typeof detail.message === "string") return detail.message;
    try { return JSON.stringify(detail); } catch (e) { return fallback; }
  }
  if (typeof error?.message === "string" && error.message) return error.message;
  return fallback;
}
